export const GIFT_CARD_DEAL_ID = 2098;
export const GIFT_CARD_OUTLET_ID = 1057;
export const GIFT_CARD_CATEGORY_ID = 2;
